import { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";

function MultipleOptionsButton({ selected, buttonLabel, options }) {
  const [state, setState] = useState(selected);
  const [disclaimer, setDisclaimer] = useState("");

  useEffect(() => {
    setState(selected);
    setDisclaimer(
      () => options.find((option) => option.value === selected)?.disclaimer
    );
  }, [options, selected]);

  return (
    <>
      <div>
        <label>{buttonLabel}</label>
        <RadioGroup value={state} onChange={setState} className="mt-1">
          <div className="flex justify-items-center">
            {options.map((option, index) => (
              <RadioGroup.Option
                as="button"
                key={option.value}
                value={option.value}
                onClick={() => option.action()}
                disabled={option.value === state}
                className={`grow m-0 py-2 border-y border-theme-primary hover:underline
              ${index === 0 && "border-l rounded-l-lg"}
              ${index > 0 && index < options.length && "border-l"}
              ${index === options.length - 1 && "border-r rounded-r-lg"}
               ${
                 option.value === state
                   ? "bg-ui-blue text-white hover:text-white cursor-auto hover:no-underline"
                   : "hover:bg-ui-blue-light"
               }`}
              >
                {option.label}
              </RadioGroup.Option>
            ))}
          </div>
          <RadioGroup.Description as="label" className="mt-1 font-normal">
            {disclaimer}
          </RadioGroup.Description>
        </RadioGroup>
      </div>
    </>
  );
}

export default MultipleOptionsButton;
